import { X } from 'lucide-react';

/**
 * Site-wide banner from settings/announcement — same styling as Home everywhere.
 */
function AnnouncementBanner({ announcement, visible, onDismiss }) {
  if (!announcement?.active || !visible) return null;

  return (
    <div className="announcement-banner">
      <div className="announcement-content">
        <p className="announcement-message">
          {announcement.message}
          {announcement.linkText && (announcement.linkUrl || announcement.scrollToSection) && (
            <>
              {' '}
              {announcement.scrollToSection ? (
                <button
                  type="button"
                  onClick={() => {
                    if (announcement.scrollToSection === 'training-modal') {
                      window.dispatchEvent(new CustomEvent('bodyworks-open-training'));
                      return;
                    }
                    const element = document.getElementById(announcement.scrollToSection);
                    if (element) {
                      const offset = 80;
                      const elementPosition = element.getBoundingClientRect().top;
                      const offsetPosition = elementPosition + window.pageYOffset - offset;
                      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                    }
                  }}
                  className="announcement-link"
                  style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                >
                  {announcement.linkText} →
                </button>
              ) : (
                <a
                  href={announcement.linkUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="announcement-link"
                >
                  {announcement.linkText} →
                </a>
              )}
            </>
          )}
        </p>
        <button
          type="button"
          className="announcement-close"
          onClick={onDismiss}
          aria-label="Close announcement"
        >
          <X size={20} />
        </button>
      </div>
    </div>
  );
}

export default AnnouncementBanner;
